export default __webpack_public_path__ + "static/media/good-things-ahead.b1fadfdf.webp";